import React from "react";

import { Disclosure } from "@headlessui/react";
import { SvgNewFile, Caret } from "@routes/IconeSvg";
import { Controller } from "react-hook-form";

import InputFileMultipleArh from "@components/input/InputFileMultiple";

import { REGEX_VALID_FILES } from "@helpers/_constants";

export default function UploadFile({
  t,
  handleUploadStatusChange,
  handleDeleteOldFiles,
  oldFiles = [],
  control,
  isDefaultOpen
}) {
  return (
    <Disclosure defaultOpen={isDefaultOpen}>
      {({ open }) => (
        <>
          <Disclosure.Button
            className={`arh-mt-2 arh-flex arh-w-full arh-items-center arh-justify-between arh-rounded-md arh-border arh-border-solid arh-border-greyBorderInput arh-bg-transparent arh-p-4 ${
              open && "arh-rounded-bl-none arh-rounded-br-none arh-border-b-0"
            }`}
          >
            <div className="arh-flex arh-items-center arh-space-x-3">
              <span>{SvgNewFile()}</span>
              <span className="arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
                {t("Ajouter un fichier")}
              </span>
            </div>
            <span>
              <Caret
                className={`${open ? "arh-rotate-90" : "arh-rotate-0"}`}
                aria-hidden="true"
              />
            </span>
          </Disclosure.Button>
          <Disclosure.Panel
            className={`input_file_theme_employer  arh-rounded-md arh-border arh-border-solid arh-border-greyBorderInput arh-p-4 ${
              open && "arh-rounded-tl-none arh-rounded-tr-none arh-border-t-0"
            }`}
          >
            <Controller
              control={control}
              name="files"
              defaultValue={[]}
              render={({ field: { onChange, value } }) => (
                <InputFileMultipleArh
                  handleChangeStatus={handleUploadStatusChange(value, onChange)}
                  onDeleteOldFile={handleDeleteOldFiles}
                  classUploadFile="employer_theme_upload GreenThemeSelect !arh-mb-0"
                  regexp={REGEX_VALID_FILES}
                  hideTitle={true}
                  allFile={true}
                  dataFile={oldFiles}
                />
              )}
            />
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
